import { Box, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { mostraMensagemErro } from '../../helpers/Notificacoes';

interface SeletorDataProps {
    onChange: (datas: { de: Date | null; ate: Date | null }) => void;
    value?: { de: Date; ate: Date };
}

const SeletorData: React.FC<SeletorDataProps> = ({ onChange, value }) => {
    const defaultDe = new Date();
    defaultDe.setDate(defaultDe.getDate() - 7);
    const defaultAte = new Date();

    const [dataInicial, setDataInicial] = useState<Date | null>(value?.de ?? defaultDe);
    const [dataFinal, setDataFinal] = useState<Date | null>(value?.ate ?? defaultAte);

    useEffect(() => {
        if (value) {
            setDataInicial(value.de);
            setDataFinal(value.ate);
        }
    }, [value]);

    useEffect(() => {
        onChange({ de: dataInicial, ate: dataFinal });
    }, [dataInicial, dataFinal]);

    const formatDate = (date: Date | null) => {
        return date && !isNaN(date.getTime()) ? date.toISOString().slice(0, 10) : "";
    };

    const handleChange = (
        setter: React.Dispatch<React.SetStateAction<Date | null>>,
        input: string
    ) => {
        if (!input) {
            setter(null);
            return;
        }

        // Quebra a string "YYYY-MM-DD"
        const [year, month, day] = input.split("-").map(Number);

        // Cria a data no horário local (sem UTC)
        const parsed = new Date(year, month - 1, day);

        setter(parsed);
    };
    return (
        <Box sx={{ display: "flex", gap: 1 }}>
            <TextField
                type="date"
                size="small"
                label="De"
                InputLabelProps={{ shrink: true }}
                value={formatDate(dataInicial)}
                onChange={(e) => handleChange(setDataInicial, e.target.value)}
            />
            <TextField
                type="date"
                size="small"
                label="Até"
                InputLabelProps={{ shrink: true }}
                value={formatDate(dataFinal)}
                onChange={(e) => handleChange(setDataFinal, e.target.value)}
            />
        </Box>
    );
};

export default SeletorData;
